const LineupLimit = {
  soccer: {
    lineup: 11,
    quarters: 2,
    quarterTime: 45,
    subs: 5
  },
  "aussie rules football": {
    lineup: 18,
    quarters: 2,
    quarterTime: 45,
    subs: 5
  },
  "american football": {
    lineup: 11,
    quarters: 2,
    quarterTime: 45,
    subs: 5
  },
  rugby: {
    lineup: 15,
    quarters: 2,
    quarterTime: 45,
    subs: 6
  },
  baseball: {
    lineup: 9,
    quarters: 2,
    quarterTime: 45,
    subs: 0
  },
  basketball: {
    lineup: 5,
    quarters: 2,
    quarterTime: 45,
    subs: 0
  },
  cricket: {
    lineup: 0,
    quarters: 2,
    quarterTime: 45,
    subs: 1
  },
  "field hockey": {
    lineup: 11,
    quarters: 2,
    quarterTime: 45,
    subs: 11
  },
  volleyball: {
    lineup: 6,
    quarters: 2,
    quarterTime: 45,
    subs: 0
  },
  "ultimate frisbee": {
    lineup: 7,
    quarters: 2,
    quarterTime: 45,
    subs: 0
  },
  netball: {
    lineup: 7,
    quarters: 2,
    quarterTime: 45,
    subs: 7
  }
};

export const availableSports = [
  "soccer",
  "rugby",
  "cricket",
  "netball",
  "field hockey"
];

export default LineupLimit;



// WEBPACK FOOTER //
// ./src/components/SportLineLimit.js